import { render } from "./KnowledgeArtifacts.vue?vue&type=template&id=78b87c4a"
import script from "./KnowledgeArtifacts.vue?vue&type=script&lang=js"
export * from "./KnowledgeArtifacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__